/* Canvas, length, poster, beats and chapters for the Home film. Kept free of
   the film's code so the registry (in the main bundle) can size the player
   before the film itself loads. */
export const FPS = 60
export const WIDTH = 1200
export const HEIGHT = 740
export const DURATION = 1200
/** For you in the spotlight: the new reply is in, and the pointer is on it. */
export const POSTER = 492

/** The film's beats, in frames. */
export const BEATS = {
  // Get set up: the banner's All steps opens Help at Get set up, then closes it.
  cursorToBanner: 104,
  allSteps: 150,
  drawerIn: 154,
  drawerClose: 226,
  drawerOut: 230,
  // For you: a reply arrives on top, the list is read, the new row opens.
  forYou: 262,
  arrival: 292,
  wash: 340,
  cursorToRow: 430,
  rowClick: 502,
  railPulse: 536,
  // Activity: a live call arrives; the pointer rests on a recorded call and presses it.
  activity: 598,
  live: 648,
  cursorToCall: 706,
  callPress: 786,
  // Paid this week: the week's bars rise, then the camera pulls back.
  paid: 900,
  barsRise: 926,
  pullBack: 1056,
} as const

export const CHAPTERS = [
  { label: 'Get set up', from: 0 },
  { label: 'For you', from: BEATS.forYou },
  { label: 'Activity', from: BEATS.activity },
  { label: 'Paid this week', from: BEATS.paid - 4 },
]
